import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex flex-column gap-4" }
const _hoisted_4 = { class: "flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "username"
}, "Username", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex flex-column gap-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "password"
}, "Password", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex flex-column gap-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "newpassword"
}, "New password (leave blank to keep)", -1)
const _hoisted_10 = { class: "flex flex-column gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "role"
}, "Role", -1)
const _hoisted_12 = {
  key: 2,
  class: "flex align-items-center gap-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "active" }, "Active", -1)
const _hoisted_14 = { class: "flex align-items-center justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PInputSwitch = _resolveComponent("PInputSwitch")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _component_PConfirmDialog = _resolveComponent("PConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_WTitle, { text: "Users" }),
          _withDirectives(_createVNode(_component_PButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAdd())),
            icon: "pi pi-plus",
            rounded: "",
            size: "small"
          }, null, 512), [
            [
              _directive_tooltip,
              `Add a new user`,
              void 0,
              { left: true }
            ]
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_PDataTable, {
          alwaysShowPaginator: false,
          loading: _ctx.loading,
          rowHover: true,
          rows: 100,
          showGridlines: true,
          stripedRows: true,
          value: _ctx.list,
          "data-key": "id",
          paginator: "",
          size: "small"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No users found.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PColumn, {
              field: "username",
              header: "Username",
              headerClass: "py-3",
              sortable: ""
            }),
            _createVNode(_component_PColumn, {
              field: "role_name",
              header: "Role",
              headerClass: "py-3",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data.role_name || '—'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              header: "Status",
              headerClass: "py-3",
              style: {"width":"110px"}
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_PTag, {
                  severity: data.active ? 'success' : 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.active ? 'Active' : 'Disabled'), 1)
                  ]),
                  _: 2
                }, 1032, ["severity"])
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              header: "Password",
              headerClass: "py-3",
              style: {"width":"140px"}
            }, {
              body: _withCtx(({ data }) => [
                (data.must_change_password)
                  ? (_openBlock(), _createBlock(_component_PTag, {
                      key: 0,
                      severity: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reset pending")
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, "—"))
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              field: "last_login",
              header: "Last login",
              headerClass: "py-3"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(data.last_login)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-right",
              headerClass: "py-3",
              style: {"width":"100px"}
            }, {
              body: _withCtx(({ data }) => [
                _withDirectives(_createVNode(_component_PButton, {
                  onClick: ($event: any) => (_ctx.openEdit(data)),
                  icon: "pi pi-pencil",
                  rounded: "",
                  severity: "success",
                  size: "small",
                  text: ""
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `Edit`,
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_PButton, {
                  onClick: ($event: any) => (_ctx.doDelete($event, data.id)),
                  icon: "pi pi-trash",
                  rounded: "",
                  severity: "danger",
                  size: "small",
                  text: ""
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `Delete`,
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value"])
      ]),
      _: 1
    }),
    _createVNode(_component_PDialog, {
      header: _ctx.editing ? 'Edit user' : 'Add a new user',
      onHide: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeDialog())),
      modal: "",
      style: {"width":"28rem","max-width":"95vw"},
      visible: _ctx.showDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_PInputText, {
              disabled: _ctx.editing,
              autocomplete: "off",
              id: "username",
              size: "small",
              modelValue: _ctx.item.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.username) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_PInputText, {
                  autocomplete: "new-password",
                  id: "password",
                  size: "small",
                  type: "password",
                  modelValue: _ctx.item.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.password) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_PInputText, {
                  autocomplete: "new-password",
                  id: "newpassword",
                  size: "small",
                  type: "password",
                  modelValue: _ctx.item.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.password) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_PDropdown, {
              options: _ctx.roles,
              id: "role",
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select a role",
              modelValue: _ctx.item.role_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.role_id) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          (_ctx.editing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_PInputSwitch, {
                  "input-id": "active",
                  modelValue: _ctx.item.active,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.active) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_13
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_PButton, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editing ? _ctx.saveUpdates() : _ctx.doAdd())),
              label: "Save",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeDialog())),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_PConfirmDialog)
  ], 64))
}